import React, { useState } from "react";
import { importLearningOutcomesFromFile } from "../web/src/services/importService";

const PRIMARY_BLUE = "#1565C0";
const BG = "#f4f7fb";
const CARD_BG = "#ffffff";
const BORDER = "#dbe3ee";
const TEXT_DARK = "#0f172a";
const TEXT_MUTED = "#64748b";

export default function LearningOutcomesEditPage() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  function handleFileChange(e) {
    const selected = e.target.files?.[0] || null;
    setFile(selected);
    setError("");
    setResult(null);
  }

  async function handleImport() {
    setError("");
    setResult(null);

    if (!file) {
      setError("Lütfen önce bir Excel dosyası seçin.");
      return;
    }

    try {
      setLoading(true);
      const response = await importLearningOutcomesFromFile(file);
      setResult(response.report);
    } catch (err) {
      console.error("LEARNING OUTCOMES IMPORT ERROR:", err);
      setError(err.message || "Import sırasında hata oluştu.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.sectionHeader}>
          <div>
            <h2 style={styles.title}>Öğrenme Kazanımları İçe Aktarma</h2>
            <p style={styles.subtitle}>
              Excel dosyasından öğrenme kazanımlarını toplu olarak yükleyin.
            </p>
          </div>
        </div>

        <div style={styles.importBox}>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileChange}
            style={styles.fileInput}
          />

          {file && (
            <p style={styles.fileInfo}>
              Seçilen dosya: <strong>{file.name}</strong>
            </p>
          )}

          <div style={styles.buttonRow}>
            <button
              type="button"
              onClick={handleImport}
              disabled={loading}
              style={styles.primaryButton}
            >
              {loading ? "İçe aktarılıyor..." : "İçe Aktar"}
            </button>
          </div>

          {error && <p style={styles.error}>{error}</p>}

          {result && (
            <div style={styles.resultBox}>
              <h3 style={styles.resultTitle}>Import Sonucu</h3>

              <div style={styles.resultStats}>
                <div style={styles.statItem}>
                  <span style={styles.statLabel}>Toplam Satır</span>
                  <strong>{result.totalRows}</strong>
                </div>

                <div style={styles.statItem}>
                  <span style={styles.statLabel}>Başarılı</span>
                  <strong>{result.successCount}</strong>
                </div>

                <div style={styles.statItem}>
                  <span style={styles.statLabel}>Başarısız</span>
                  <strong>{result.failedCount}</strong>
                </div>
              </div>

              <pre style={styles.pre}>{JSON.stringify(result, null, 2)}</pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: BG,
    padding: 24,
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
  },
  card: {
    maxWidth: 960,
    margin: "0 auto",
    background: CARD_BG,
    padding: 24,
    borderRadius: 20,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
    border: `1px solid ${BORDER}`
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 20
  },
  title: {
    margin: 0,
    color: TEXT_DARK,
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: "-0.02em"
  },
  subtitle: {
    margin: "6px 0 0 0",
    color: TEXT_MUTED,
    fontSize: 14,
    lineHeight: 1.6
  },
  importBox: {
    display: "grid",
    gap: 14
  },
  fileInput: {
    fontSize: 14
  },
  fileInfo: {
    margin: 0,
    color: TEXT_MUTED,
    fontSize: 14
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-start"
  },
  primaryButton: {
    minHeight: 44,
    padding: "0 18px",
    borderRadius: 12,
    border: "none",
    background: PRIMARY_BLUE,
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 8px 18px rgba(21, 101, 192, 0.18)"
  },
  resultBox: {
    marginTop: 8,
    background: "#f8fafc",
    padding: 16,
    borderRadius: 14,
    border: `1px solid ${BORDER}`
  },
  resultTitle: {
    marginTop: 0,
    marginBottom: 12,
    fontSize: 18,
    color: TEXT_DARK
  },
  resultStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 12,
    marginBottom: 16
  },
  statItem: {
    background: "#fff",
    border: `1px solid ${BORDER}`,
    borderRadius: 12,
    padding: 12
  },
  statLabel: {
    display: "block",
    fontSize: 12,
    color: TEXT_MUTED,
    marginBottom: 6
  },
  pre: {
    margin: 0,
    background: "#fff",
    padding: 12,
    borderRadius: 12,
    overflowX: "auto",
    border: `1px solid ${BORDER}`,
    fontSize: 12
  },
  error: {
    color: "crimson",
    marginTop: 8,
    fontSize: 14,
    lineHeight: 1.5
  }
};